module.exports = __webpack_public_path__ + "img/EXIMBANK.b684b62e.svg";